// extracted by mini-css-extract-plugin
export default {"ChangeTextLink":"ChangeTextLink_ChangeTextLink__138N-","LinkIcon":"ChangeTextLink_LinkIcon__uBDep"};